function deselectCartItems() {
  fetch('/cart.js', { cache: 'no-store' })
    .then(res => res.json())
    .then(cart => {
      const cartVariantIds = cart.items.map(item => item.variant_id);

      document.querySelectorAll('.bundle').forEach(bundle => {
        const variantId = parseInt(bundle.getAttribute('value'));
        if (cartVariantIds.includes(variantId)) {
          bundle.classList.remove('active');
          const checkbox = bundle.querySelector('.bundle-checkbox');
          if (checkbox) checkbox.checked = false;
        }
      });
    })
    .catch(err => console.error('Cart fetch failed:', err));
}

document.addEventListener('DOMContentLoaded', function () {
  let bundlerun = document.querySelector('.product-bundles');
  if (!bundlerun) return;

  deselectCartItems();

  const button = document.querySelector('.kit-footer .custom-button');
  const originalButtonText = button ? button.innerHTML : 'Add to Cart';

  document.querySelectorAll('.kit-bottom').forEach(product => {
    product.querySelectorAll('.bundle').forEach((elem) => {
      elem.addEventListener('click', function (e) {
        const quantityDiv = this.querySelector('.quantity');
        if (quantityDiv && quantityDiv.contains(e.target)) return;

        const isAvailable = this.getAttribute('data-available') === 'true';
        if (!isAvailable) return;

        e.preventDefault();
        elem.classList.toggle('active');

        let checkbox = this.querySelector('.bundle-checkbox');
        if (checkbox) {
          checkbox.checked = this.classList.contains('active');
        }
      });
    });

    if (!button) return;

    button.addEventListener('click', async function () {
      const errorDiv = document.querySelector('.error-msg');
      if (errorDiv) errorDiv.textContent = '';

      var items = [];
      let mainContainer = document.querySelector('.kit-bottom');

      let mainItemQuantity = 1;
      let mainItemQuantitySelector = document.querySelector('.default-qty');
      if (mainItemQuantitySelector) {
        mainItemQuantity = parseInt(mainItemQuantitySelector.value);
      }

      let defaultElement = document.querySelector('.variant-pill.active');
      if (defaultElement) {
        let defaultVariantId = defaultElement.getAttribute('variant-id');
        if (defaultVariantId) {
          items.push({ id: parseInt(defaultVariantId), quantity: mainItemQuantity });
        }
      }

      mainContainer.querySelectorAll('.bundle.active').forEach((activeBundle) => {
        let bundleVariantId = activeBundle.getAttribute('value');
        let isAvailable = activeBundle.getAttribute('data-available') === 'true';
        let bundleqty = activeBundle.querySelector('.bundle-quantity');
        let bundlevalue = bundleqty ? parseInt(bundleqty.value) : 1;

        if (bundleVariantId && isAvailable) {
          items.push({ id: parseInt(bundleVariantId), quantity: bundlevalue });
        } else if (bundleVariantId && !isAvailable) {
          activeBundle.classList.remove('active');
        }
      });

      if (items.length === 0) return;

      button.disabled = true;
      button.innerHTML = `<span class="btn-spinner"></span>`;

      try {
        const cartResponse = await fetch('/cart.js', { cache: 'no-store' });
        const cart = await cartResponse.json();

        const cartQtyMap = {};
        cart.items.forEach(cartItem => {
          cartQtyMap[cartItem.variant_id] = (cartQtyMap[cartItem.variant_id] || 0) + cartItem.quantity;
        });

        for (const item of items) {
          const bundleEl =
            mainContainer.querySelector(`.bundle[value="${item.id}"]`) ||
            document.querySelector(`.variant-pill[variant-id="${item.id}"]`);

          if (!bundleEl) continue;

          const inventoryPolicy = bundleEl.getAttribute('data-inventory-policy');
          const inventoryQty    = parseInt(bundleEl.getAttribute('data-inventory'), 10);

          if (inventoryPolicy === 'continue') continue;

          if (inventoryPolicy === 'deny') {
            const alreadyInCart  = cartQtyMap[item.id] || 0;
            const totalRequested = alreadyInCart + item.quantity;

            if (totalRequested > inventoryQty) {
              const productTitle = bundleEl.getAttribute('data-title') || bundleEl.textContent.trim() || 'This product';
              const remaining    = inventoryQty - alreadyInCart;

              if (errorDiv) {
                errorDiv.textContent = remaining <= 0
                  ? `"${productTitle}" is already at maximum quantity in your cart.`
                  : `"${productTitle}" only has ${remaining} unit${remaining !== 1 ? 's' : ''} left. You already have ${alreadyInCart} in your cart.`;

                errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }

              button.disabled  = false;
              button.innerHTML = originalButtonText;
              return;
            }
          }
        }

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!addResponse.ok) throw new Error(`HTTP error! status: ${addResponse.status}`);

        window.location.href = '/cart';

      } catch (err) {
        console.error('Add to cart failed:', err);
        button.disabled  = false;
        button.innerHTML = originalButtonText;
      }
    });
  });

  // Fires when user comes back via browser back button (cached page)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      deselectCartItems();

      if (button) {
        button.disabled = false;
        button.innerHTML = originalButtonText;
      }
    }
  });

});